import { TabTpSrv } from './tab-tp-srv';
import { EstadoCivil } from './estado-civil';
import { RegimeJuridico } from './regime-juridico';
import { GrauEscolaridade } from './grau-escolaridade';
import { Raca } from './raca';
import { VagasCatFunc } from './vagas-cat-func';
import { Nacionalidade } from './nacionalidade';
import { TabSiFunc } from './tab-si-func';

export class ServidorSrh2 {
  matServidor: string = null;
  nom: string = null;
  nomAntServ: string = null;
  sexo: string = null;
  logradouro: string = null;
  bairro: string = null;
  cep: string = null;
  cidade: string = null;
  uf: string = null;
  foneCelularServ: string = null;
  eMail: string = null;
  telefone: string = null;
  dtNasc: Date = null;
  dtFalecServ: Date = null;
  anoChegada: string = null;
  naturalidade: string = null;
  nacionalidade: Nacionalidade = null;
  nomPai: string = null;
  nomMae: string = null;
  nomConjuge: string = null;
  alergia: number = null;
  deficiente: number = null;
  alSrv: number = null;
  raca: Raca = null;
  crOlSrv: string = null;
  crCaSrv: string = null;
  tpSanSrv: string = null;
  doador: number = null;
  ufNatural: string = null;
  //codEscolar: number = null;
  //codEstCivil: number = null;
  grauEscolaridade: GrauEscolaridade = null;
  estadoCivil: EstadoCivil = null;
  numCertCasam: string = null;
  numCpf: string = null;
  numPispasep: number = null;
  numId: string = null;
  orgExpRg: string = null;
  dtEmissaoId: Date = null;
  ufId: string = null;
  numTitEle: string = null;
  zonaTitEle: string = null;
  secaoTitEle: string = null;
  municTitEle: string = null;
  dtEmisTitEle: Date = null;
  ufTitEle: string = null;
  dtUltVotacao: Date = null;
  numHabProf: string = null;
  orgExpHabProf: string = null;
  dsRegHpSrv: string = null;
  dtHabProf: Date = null;
  ufHabProf: string = null;
  numReserv: string = null;
  categReserv: string = null;
  dtEmisReserv: Date = null;
  ufReserv: string = null;
  orgReserv: string = null;
  rmReserv: number = null;
  numHabilit: string = null;
  validHabilit: Date = null;
  catHabilit: string = null;
  dtHabilit: Date = null;
  nrCtpsSrv: string = null;
  srCtpsSrv: number = null;
  dtEmCtpsSrv: Date = null;
  numCtaBanco: string = null;
  codOpCt: string = null;
  cdAge: string = null;
  cdBco: string = null;
  cdRegTrb: number = null;
  //cdTipServ: number = null;
  tipServ: TabTpSrv = null;
  cdIng: number = null;
  //cdSiFunc: number = null;
  siFunc: TabSiFunc = null;
  orgReq: number = null;
  cbo: string = null;
  codTcu: string = null;
  dtIngresso: Date = null;
  atoIngresso: number = null;
  dtVctoEst: Date = null;
  dtNomeacao: Date = null;
  dtPublNomea: Date = null;
  dtPosse: Date = null;
  dtExercFerias: Date = null;
  orgConcurso: number = null;
  nrEdt: string = null;
  nrClSrv: number = null;
  dtEdt: Date = null;
  dtHmConc: Date = null;
  dtVdConc: Date = null;
  unidLot: number = null;
  dsAndTrb: string = null;
  dsSlTrbSrv: string = null;
  nrFnTrbSrv: string = null; //ramal
  //cdRgJur: number = null;
  regimeJuridico: RegimeJuridico = null;
  orgCes: number = null;
  dtCessao: Date = null;
  atoDeslig: number = null;
  dtDeslig: Date = null;
  dtDocDeslig: Date = null;
  dtPublDeslig: Date = null;
  matAntServ: string = null;
  //cargo: number = null;
  numVaga: number = null;
  //cargo: Cargo = null;
  vaga: VagasCatFunc = null;
  numDocDeslig: string = null;
  numDocIngresso: string = null;
  numPortDesig: number = null;
  dtPortDesig: Date = null;
  dtDesig: Date = null;
  acProventos: number = null;
  acVencimento: number = null;
  acCargo: number = null;
  cargoAcumulado: string = null;
  dtAcCargo: Date = null;
  dtLimRetReq: Date = null;
  cargoReq: string = null;
  tpFerias: number = null;
  ctrFerias: string = null;
  ctrFrequencia: string = null;
  nrFerias: number = null;
  seqReferencia: number = null;
  codCom: string = null;
  nomeCom: string = null;
  numVagaCom: number = null;
  codFc: string = null;
  ds: string = null;
  numVagaFc: number = null;
  numProcTcu: string = null;
  veicPublicTcu: number = null;
  dtPublicProcTcu: Date = null;
  nomeCracha: string = null;
  matServCompleta: string = null;
  doadorSangue: string = null;
  numProcTcuDeslig: string = null;
  veicPublicTcuDeslig: number = null;
  dtPublicProcTcuDeslig: Date = null;
  dtJulgamento: Date = null;
  ataJulgamento: string = null;
  numRegControle: string = null;
  login: string = null;
  uniaoEstavel: string = null;
  cdSitEstCiv: number = null;
  eMailExterno: string = null;
  dtJulgamentoDeslig: Date = null;
  ataJulgamentoDeslig: string = null;
  numRegControleDeslig: string = null;
  numCracha: number = null;
  numCartaoPonto: number = null;
  logradouroCorr: string = null;
  bairroCorr: string = null;
  cepCorr: string = null;
  cidadeCorr: string = null;
  ufCorr: string = null;
  numCartaoAcesso: number = null;
  horarioPadrao: number = null;
  tipUsuario: string = null;
  seqConcurso: number = null;
  codCandidato: string = null;
  pesoSrv: number = null;
  cdProtPastaFunc: string = null;
  stLiberaConsultaPerfil: string = null;
  cdVeicPublicProv: number = null;
  cdVeicPublicDeslig: number = null;
  tpContaCorrenteServ: string = null;
  stConjugeServidor: number = null;
  numCartFuncMagistrado: number = null;
  dddTelefone: number = null;
  dddCelular: number = null;
  numLogradouro: string = null;
  complLogradouro: string = null;
  cadNacionalSaude: string = null;
  nomSocial: string = null;
  numCartSus: string = null;
  dtExercPriProv: Date = null;
  exibirDadosIntranet: number = null;
  cdLogradouro: string = null;
  cdMunicipioRes: number = null;
  cdPais: number = null;
  cdPaisNascimento: number = null;
  cdPaisNacionalidade: number = null;
  municipioExtNaturalidade: string = null;
  cdMunicipioNaturalidade: number = null;
  ricNum: string = null;
  ricOrgEmissor: string = null;
  ricDtExpedicao: Date = null;
  rneNum: string = null;
  rneOrgEmissor: string = null;
  rneDtExpedicao: Date = null;
  dtValidadeHabProf: Date = null;
  dtPrimeiraHabilit: Date = null;
  ufHabilit: string = null;
  transexualTravesti: number = null;
  cotaDeficiente: string = null;
  readaptado: string = null;
  numCertidaoObito: string = null;
  primeiroEmprego: string = null;
  ajusteDeGenero: string = null;
  estrDtChegada: Date = null;
  estrCdCondicao: number = null;
  estrCasadoComBrasileiro: string = null;
  estrTemFilhoBrasileiro: string = null;

  constructor(d?) {
    if (d) {
      this.matServidor = d.matServidor ? d.matServidor : null;
      this.nom = d.nom ? d.nom : null;
      this.nomAntServ = d.nomAntServ ? d.nomAntServ : null;
      this.sexo = d.sexo ? d.sexo : null;
      this.logradouro = d.logradouro ? d.logradouro : null;
      this.bairro = d.bairro ? d.bairro : null;
      this.cep = d.cep ? d.cep : null;
      this.cidade = d.cidade ? d.cidade : null;
      this.uf = d.uf ? d.uf : null;
      this.foneCelularServ = d.foneCelularServ ? d.foneCelularServ : null;
      this.eMail = d.eMail ? d.eMail : null;
      this.telefone = d.telefone ? d.telefone : null;
      this.dtNasc = d.dtNasc ? d.dtNasc : null;
      this.dtFalecServ = d.dtFalecServ ? d.dtFalecServ : null;
      this.anoChegada = d.anoChegada ? d.anoChegada : null;
      this.naturalidade = d.naturalidade ? d.naturalidade : null;
      //this.nacionalidade = d.nacionalidade ? d.nacionalidade : null;
      this.nacionalidade = d.nacionalidade
        ? new Nacionalidade(d.nacionalidade)
        : null;
      this.nomPai = d.nomPai ? d.nomPai : null;
      this.nomMae = d.nomMae ? d.nomMae : null;
      this.nomConjuge = d.nomConjuge ? d.nomConjuge : null;
      this.alergia = d.alergia ? d.alergia : null;
      this.deficiente = d.deficiente ? d.deficiente : null;
      this.alSrv = d.alSrv ? d.alSrv : null;
      //this.crPlSrv = d.crPlSrv ? d.crPlSrv : null;
      this.raca = d.raca ? new Raca(d.raca) : null;
      this.crOlSrv = d.crOlSrv ? d.crOlSrv : null;
      this.crCaSrv = d.crCaSrv ? d.crCaSrv : null;
      this.tpSanSrv = d.tpSanSrv ? d.tpSanSrv : null;
      this.doador = d.doador ? d.doador : null;
      this.ufNatural = d.ufNatural ? d.ufNatural : null;
      //this.codEscolar = d.codEscolar ? d.codEscolar : null;
      //this.codEstCivil = d.codEstCivil ? d.codEstCivil : null;
      this.estadoCivil = d.estadoCivil ? new EstadoCivil(d.estadoCivil) : null;
      this.grauEscolaridade = d.grauEscolaridade
        ? new GrauEscolaridade(d.grauEscolaridade)
        : null;
      this.numCertCasam = d.numCertCasam ? d.numCertCasam : null;
      this.numCpf = d.numCpf ? d.numCpf : null;
      this.numPispasep = d.numPispasep ? d.numPispasep : null;
      this.numId = d.numId ? d.numId : null;
      this.orgExpRg = d.orgExpRg ? d.orgExpRg : null;
      this.dtEmissaoId = d.dtEmissaoId ? d.dtEmissaoId : null;
      this.ufId = d.ufId ? d.ufId : null;
      this.numTitEle = d.numTitEle ? d.numTitEle : null;
      this.zonaTitEle = d.zonaTitEle ? d.zonaTitEle : null;
      this.secaoTitEle = d.secaoTitEle ? d.secaoTitEle : null;
      this.municTitEle = d.municTitEle ? d.municTitEle : null;
      this.dtEmisTitEle = d.dtEmisTitEle ? d.dtEmisTitEle : null;
      this.ufTitEle = d.ufTitEle ? d.ufTitEle : null;
      this.dtUltVotacao = d.dtUltVotacao ? d.dtUltVotacao : null;
      this.numHabProf = d.numHabProf ? d.numHabProf : null;
      this.orgExpHabProf = d.orgExpHabProf ? d.orgExpHabProf : null;
      this.dsRegHpSrv = d.dsRegHpSrv ? d.dsRegHpSrv : null;
      this.dtHabProf = d.dtHabProf ? d.dtHabProf : null;
      this.ufHabProf = d.ufHabProf ? d.ufHabProf : null;
      this.numReserv = d.numReserv ? d.numReserv : null;
      this.categReserv = d.categReserv ? d.categReserv : null;
      this.dtEmisReserv = d.dtEmisReserv ? d.dtEmisReserv : null;
      this.ufReserv = d.ufReserv ? d.ufReserv : null;
      this.orgReserv = d.orgReserv ? d.orgReserv : null;
      this.rmReserv = d.rmReserv ? d.rmReserv : null;
      this.numHabilit = d.numHabilit ? d.numHabilit : null;
      this.validHabilit = d.validHabilit ? d.validHabilit : null;
      this.catHabilit = d.catHabilit ? d.catHabilit : null;
      this.dtHabilit = d.dtHabilit ? d.dtHabilit : null;
      this.nrCtpsSrv = d.nrCtpsSrv ? d.nrCtpsSrv : null;
      this.srCtpsSrv = d.srCtpsSrv ? d.srCtpsSrv : null;
      this.dtEmCtpsSrv = d.dtEmCtpsSrv ? d.dtEmCtpsSrv : null;
      this.numCtaBanco = d.numCtaBanco ? d.numCtaBanco : null;
      this.codOpCt = d.codOpCt ? d.codOpCt : null;
      this.cdAge = d.cdAge ? d.cdAge : null;
      this.cdBco = d.cdBco ? d.cdBco : null;
      this.cdRegTrb = d.cdRegTrb ? d.cdRegTrb : null;
      //this.cdTipServ = d.cdTipServ ? d.cdTipServ : null;
      this.tipServ = d.tipServ ? new TabTpSrv(d.tipServ) : null;
      this.cdIng = d.cdIng ? d.cdIng : null;
      //this.cdSiFunc = d.cdSiFunc ? d.cdSiFunc : null;
      this.siFunc = d.siFunc ? new TabSiFunc(d.siFunc) : null;
      this.orgReq = d.orgReq ? d.orgReq : null;
      this.cbo = d.cbo ? d.cbo : null;
      this.codTcu = d.codTcu ? d.codTcu : null;
      this.dtIngresso = d.dtIngresso ? d.dtIngresso : null;
      this.atoIngresso = d.atoIngresso ? d.atoIngresso : null;
      this.dtVctoEst = d.dtVctoEst ? d.dtVctoEst : null;
      this.dtNomeacao = d.dtNomeacao ? d.dtNomeacao : null;
      this.dtPublNomea = d.dtPublNomea ? d.dtPublNomea : null;
      this.dtPosse = d.dtPosse ? d.dtPosse : null;
      this.dtExercFerias = d.dtExercFerias ? d.dtExercFerias : null;
      this.orgConcurso = d.orgConcurso ? d.orgConcurso : null;
      this.nrEdt = d.nrEdt ? d.nrEdt : null;
      this.nrClSrv = d.nrClSrv ? d.nrClSrv : null;
      this.dtEdt = d.dtEdt ? d.dtEdt : null;
      this.dtHmConc = d.dtHmConc ? d.dtHmConc : null;
      this.dtVdConc = d.dtVdConc ? d.dtVdConc : null;
      this.unidLot = d.unidLot ? d.unidLot : null;
      this.dsAndTrb = d.dsAndTrb ? d.dsAndTrb : null;
      this.dsSlTrbSrv = d.dsSlTrbSrv ? d.dsSlTrbSrv : null;
      this.nrFnTrbSrv = d.nrFnTrbSrv ? d.nrFnTrbSrv : null;
      this.regimeJuridico = d.regimeJuridico
        ? new RegimeJuridico(d.regimeJuridico)
        : null;
      //this.cdRgJur = d.cdRgJur ? d.cdRgJur : null;
      this.orgCes = d.orgCes ? d.orgCes : null;
      this.dtCessao = d.dtCessao ? d.dtCessao : null;
      this.atoDeslig = d.atoDeslig ? d.atoDeslig : null;
      this.dtDeslig = d.dtDeslig ? d.dtDeslig : null;
      this.dtDocDeslig = d.dtDocDeslig ? d.dtDocDeslig : null;
      this.dtPublDeslig = d.dtPublDeslig ? d.dtPublDeslig : null;
      this.matAntServ = d.matAntServ ? d.matAntServ : null;
      //this.cargo = d.cargo ? d.cargo : null;
      //this.cargo = d.cargo ? new Cargo(d.cargo) : null;
      this.numVaga = d.numVaga ? d.numVaga : null;
      this.vaga = d.vaga ? new VagasCatFunc(d.vaga) : null;
      this.numDocDeslig = d.numDocDeslig ? d.numDocDeslig : null;
      this.numDocIngresso = d.numDocIngresso ? d.numDocIngresso : null;
      this.numPortDesig = d.numPortDesig ? d.numPortDesig : null;
      this.dtPortDesig = d.dtPortDesig ? d.dtPortDesig : null;
      this.dtDesig = d.dtDesig ? d.dtDesig : null;
      this.acProventos = d.acProventos ? d.acProventos : null;
      this.acVencimento = d.acVencimento ? d.acVencimento : null;
      this.acCargo = d.acCargo ? d.acCargo : null;
      this.cargoAcumulado = d.cargoAcumulado ? d.cargoAcumulado : null;
      this.dtAcCargo = d.dtAcCargo ? d.dtAcCargo : null;
      this.dtLimRetReq = d.dtLimRetReq ? d.dtLimRetReq : null;
      this.cargoReq = d.cargoReq ? d.cargoReq : null;
      this.tpFerias = d.tpFerias ? d.tpFerias : null;
      this.ctrFerias = d.ctrFerias ? d.ctrFerias : null;
      this.ctrFrequencia = d.ctrFrequencia ? d.ctrFrequencia : null;
      this.nrFerias = d.nrFerias ? d.nrFerias : null;
      this.seqReferencia = d.seqReferencia ? d.seqReferencia : null;
      this.codCom = d.codCom ? d.codCom : null;
      this.nomeCom = d.nomeCom ? d.nomeCom : null;
      this.numVagaCom = d.numVagaCom ? d.numVagaCom : null;
      this.codFc = d.codFc ? d.codFc : null;
      this.ds = d.ds ? d.ds : null;
      this.numVagaFc = d.numVagaFc ? d.numVagaFc : null;
      this.numProcTcu = d.numProcTcu ? d.numProcTcu : null;
      this.veicPublicTcu = d.veicPublicTcu ? d.veicPublicTcu : null;
      this.dtPublicProcTcu = d.dtPublicProcTcu ? d.dtPublicProcTcu : null;
      this.nomeCracha = d.nomeCracha ? d.nomeCracha : null;
      this.matServCompleta = d.matServCompleta ? d.matServCompleta : null;
      this.doadorSangue = d.doadorSangue ? d.doadorSangue : null;
      this.numProcTcuDeslig = d.numProcTcuDeslig ? d.numProcTcuDeslig : null;
      this.veicPublicTcuDeslig = d.veicPublicTcuDeslig
        ? d.veicPublicTcuDeslig
        : null;
      this.dtPublicProcTcuDeslig = d.dtPublicProcTcuDeslig
        ? d.dtPublicProcTcuDeslig
        : null;
      this.dtJulgamento = d.dtJulgamento ? d.dtJulgamento : null;
      this.ataJulgamento = d.ataJulgamento ? d.ataJulgamento : null;
      this.numRegControle = d.numRegControle ? d.numRegControle : null;
      this.login = d.login ? d.login : null;
      this.uniaoEstavel = d.uniaoEstavel ? d.uniaoEstavel : null;
      this.cdSitEstCiv = d.cdSitEstCiv ? d.cdSitEstCiv : null;
      this.eMailExterno = d.eMailExterno ? d.eMailExterno : null;
      this.dtJulgamentoDeslig = d.dtJulgamentoDeslig
        ? d.dtJulgamentoDeslig
        : null;
      this.ataJulgamentoDeslig = d.ataJulgamentoDeslig
        ? d.ataJulgamentoDeslig
        : null;
      this.numRegControleDeslig = d.numRegControleDeslig
        ? d.numRegControleDeslig
        : null;
      this.numCracha = d.numCracha ? d.numCracha : null;
      this.numCartaoPonto = d.numCartaoPonto ? d.numCartaoPonto : null;
      this.logradouroCorr = d.logradouroCorr ? d.logradouroCorr : null;
      this.bairroCorr = d.bairroCorr ? d.bairroCorr : null;
      this.cepCorr = d.cepCorr ? d.cepCorr : null;
      this.cidadeCorr = d.cidadeCorr ? d.cidadeCorr : null;
      this.ufCorr = d.ufCorr ? d.ufCorr : null;
      this.numCartaoAcesso = d.numCartaoAcesso ? d.numCartaoAcesso : null;
      this.horarioPadrao = d.horarioPadrao ? d.horarioPadrao : null;
      this.tipUsuario = d.tipUsuario ? d.tipUsuario : null;
      this.seqConcurso = d.seqConcurso ? d.seqConcurso : null;
      this.codCandidato = d.codCandidato ? d.codCandidato : null;
      this.pesoSrv = d.pesoSrv ? d.pesoSrv : null;
      this.cdProtPastaFunc = d.cdProtPastaFunc ? d.cdProtPastaFunc : null;
      this.stLiberaConsultaPerfil = d.stLiberaConsultaPerfil
        ? d.stLiberaConsultaPerfil
        : null;
      this.cdVeicPublicProv = d.cdVeicPublicProv ? d.cdVeicPublicProv : null;
      this.cdVeicPublicDeslig = d.cdVeicPublicDeslig
        ? d.cdVeicPublicDeslig
        : null;
      this.tpContaCorrenteServ = d.tpContaCorrenteServ
        ? d.tpContaCorrenteServ
        : null;
      this.stConjugeServidor = d.stConjugeServidor ? d.stConjugeServidor : null;
      this.numCartFuncMagistrado = d.numCartFuncMagistrado
        ? d.numCartFuncMagistrado
        : null;
      this.dddTelefone = d.dddTelefone ? d.dddTelefone : null;
      this.dddCelular = d.dddCelular ? d.dddCelular : null;
      this.numLogradouro = d.numLogradouro ? d.numLogradouro : null;
      this.complLogradouro = d.complLogradouro ? d.complLogradouro : null;
      this.cadNacionalSaude = d.cadNacionalSaude ? d.cadNacionalSaude : null;
      this.nomSocial = d.nomSocial ? d.nomSocial : null;
      this.numCartSus = d.numCartSus ? d.numCartSus : null;
      this.dtExercPriProv = d.dtExercPriProv ? d.dtExercPriProv : null;
      this.exibirDadosIntranet = d.exibirDadosIntranet
        ? d.exibirDadosIntranet
        : null;
      this.cdLogradouro = d.cdLogradouro ? d.cdLogradouro : null;
      this.cdMunicipioRes = d.cdMunicipioRes ? d.cdMunicipioRes : null;
      this.cdPais = d.cdPais ? d.cdPais : null;
      this.cdPaisNascimento = d.cdPaisNascimento ? d.cdPaisNascimento : null;
      this.cdPaisNacionalidade = d.cdPaisNacionalidade
        ? d.cdPaisNacionalidade
        : null;
      this.municipioExtNaturalidade = d.municipioExtNaturalidade
        ? d.municipioExtNaturalidade
        : null;
      this.cdMunicipioNaturalidade = d.cdMunicipioNaturalidade
        ? d.cdMunicipioNaturalidade
        : null;
      this.ricNum = d.ricNum ? d.ricNum : null;
      this.ricOrgEmissor = d.ricOrgEmissor ? d.ricOrgEmissor : null;
      this.ricDtExpedicao = d.ricDtExpedicao ? d.ricDtExpedicao : null;
      this.rneNum = d.rneNum ? d.rneNum : null;
      this.rneOrgEmissor = d.rneOrgEmissor ? d.rneOrgEmissor : null;
      this.rneDtExpedicao = d.rneDtExpedicao ? d.rneDtExpedicao : null;
      this.dtValidadeHabProf = d.dtValidadeHabProf ? d.dtValidadeHabProf : null;
      this.dtPrimeiraHabilit = d.dtPrimeiraHabilit ? d.dtPrimeiraHabilit : null;
      this.ufHabilit = d.ufHabilit ? d.ufHabilit : null;
      this.transexualTravesti = d.transexualTravesti
        ? d.transexualTravesti
        : null;
      this.cotaDeficiente = d.cotaDeficiente ? d.cotaDeficiente : null;
      this.readaptado = d.readaptado ? d.readaptado : null;
      this.numCertidaoObito = d.numCertidaoObito ? d.numCertidaoObito : null;
      this.primeiroEmprego = d.primeiroEmprego ? d.primeiroEmprego : null;
      this.ajusteDeGenero = d.ajusteDeGenero ? d.ajusteDeGenero : null;
      this.estrDtChegada = d.estrDtChegada ? d.estrDtChegada : null;
      this.estrCdCondicao = d.estrCdCondicao ? d.estrCdCondicao : null;
      this.estrCasadoComBrasileiro = d.estrCasadoComBrasileiro
        ? d.estrCasadoComBrasileiro
        : null;
      this.estrTemFilhoBrasileiro = d.estrTemFilhoBrasileiro
        ? d.estrTemFilhoBrasileiro
        : null;
    }
  }
}
